import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('WorkflowProfile', WorkflowProfileData);

    // WorkflowProfileData.$inject = ['UtilSvc'];
    /* @ngInject */
    function WorkflowProfileData() {
        WorkflowProfile.prototype = {
            build: build,
        };

        function WorkflowProfile(workflowProfileData) {
            if (workflowProfileData) {
                this.build(workflowProfileData);
            }
        }

        return WorkflowProfile;

        /////////////////////
        function build(workflowProfileData) {
            this.workflowName = workflowProfileData.workflowName || null;
            this.workflowScope = workflowProfileData.workflowScope || null;
            this.label = workflowProfileData.workflowName + ' - ' + workflowProfileData.label || null;
            this.code = workflowProfileData.code || null;
            this.type = workflowProfileData.type || null;
            this.role = 'USER_WKF';
        }
    }
})();
